import {round} from './Internal/round';
import {StrokeRate} from '../../../Domain/StrokeRate';

export function formatStrokeRate(strokeRate: StrokeRate | null): {formatted: string; unit?: string} {
    if (strokeRate === null) {
        return {
            formatted: '-',
        };
    }
    return {formatted: round(strokeRate.strokesPerMinute, 0), unit: 's/m'};
}

export function formatAverageStrokeRate(strokeRate: StrokeRate | null): {formatted: string; unit?: string} {
    if (strokeRate === null) {
        return {
            formatted: '-',
        };
    }
    return {formatted: round(strokeRate.strokesPerMinute, 1), unit: 's/m'};
}
